import { render, staticRenderFns } from "./storeDtl.vue?vue&type=template&id=a0c8a488&scoped=true"
import script from "./storeDtl.vue?vue&type=script&lang=js"
export * from "./storeDtl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c8a488",
  null
  
)

export default component.exports